<template>
  <v-container id="hero" fluid class="pa-0 ma-0 top-section">
    <v-row style="min-height: 80vh;" align="bottom" justify="center">
      <v-col cols="11" md="7">
        <v-container>
          <v-row align="center" justify="center" class="pl-10" style="padding-top: 20vh;">
            <v-col cols="10">
              <span class="title font-weight-medium grey--text text--darken-4">Hello, I'm</span>
              <br/><span class="display-1 font-weight-bold">Quentin Mennecart</span>
            </v-col>
            <v-col cols="10" class="ma-0 py-0">
              <v-col cols="4" class="ma-0 pa-0">
                <hr class="line-divider" />
              </v-col>
            </v-col>
            <v-col cols="10">
              <span class="headline font-weight-regular grey--text text--darken-4">Web Developer, Communicant & Photographer</span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="11" md="5" class="my-0 py-0 d-flex align-end">
        <v-img max-height="500px" contain :src="require('@/assets/avatar-me.png')" />
      </v-col>
    </v-row>
    <div class="bottom-section" />
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
/*.top-section {
  position: relative;
  background-image: linear-gradient(19deg,rgba(179,121,247, 0.8) 56%,rgba(179,121,247, 0.9) 49%)!important;
}*/
.top-section {
  position: relative;
  background-image: linear-gradient(19deg,rgba(250,250,250, 0.8) 56%,rgba(250,250,250, 0.9) 49%)!important;
}
.line-divider {
  border-radius: 10px;
  background-image: linear-gradient(160deg,rgba(0, 0, 0, 0) 0%, rgba(20, 20, 20) 88%);
  height: 5px;
  width: 150px;
  border: 0 none;
}
.bottom-section {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSI1NXB4IiB2aWV3Qm94PSIwIDAgMTI4MCAxNDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzFFMjUyOCI+PHBhdGggZD0iTTAgMHYxNDBoMTI4MEwwIDB6Ii8+PC9nPjwvc3ZnPg==);
  background-size: 100% 80px;
  bottom: 0;
  height: 80px;
  z-index: 8;
  transform: rotateY(0) rotateX(0);
  position: absolute;
  width: 100%;
  display: block;
  margin-bottom: -1px;
}
</style>